import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiService } from '../Services/apiService';
import { useAuth } from './AuthContext';

const GameContext = createContext();

export const useGames = () => useContext(GameContext);

export const GameProvider = ({ children }) => {
  const [games, setGames] = useState([]);
  const [activeGameId, setActiveGameId] = useState(() => {
    const saved = localStorage.getItem('activeGameId');
    return saved ? Number(saved) : null;
  });

  useEffect(() => {
    if (activeGameId) {
      localStorage.setItem('activeGameId', activeGameId);
    } else {
      localStorage.removeItem('activeGameId');
    }
  }, [activeGameId]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      fetchGames();
    } else {
      setGames([]);
    }
  }, [user]);

  const fetchGames = async () => {
    try {
        setLoading(true);
        setError(null);
        const data = await apiService.getAllGames();
        setGames(data || []);
    } catch (err) {
      console.error("Failed to fetch games:", err);
      setError(`Hata: ${err.message || 'Oyunlar yüklenemedi.'}`);
    } finally {
        setLoading(false);
    }
  };

  const updateGame = async (id, updatedData) => {
     try {
        const updatedGame = await apiService.updateGame(id, updatedData);
        setGames(prevGames => prevGames.map(g => g.id === Number(id) ? updatedGame : g));
        return updatedGame;
     } catch (err) {
        console.error("Failed to update game", err);
        throw err;
     }
  };
  
  const addGame = async (game) => {
    try {
        console.log("GameContext: Adding game...", game);
        const newGame = await apiService.createGame(game);
        console.log("GameContext: API Response:", newGame);
        if (newGame && newGame.id) {
            setGames(prevGames => [...prevGames, newGame]);
            console.log("GameContext: State updated with new game.");
            return newGame;
        } else {
            console.error("GameContext: Invalid API response", newGame);
            throw new Error("Invalid API response");
        }
    } catch (err) {
        console.error("Failed to add game", err);
        setError("Oyun oluşturulamadı.");
    }
  };

  const deleteGame = async (id) => {
    try {
        await apiService.deleteGame(id);
        setGames(games.filter(g => g.id !== id));
    } catch (err) {
        console.error("Failed to delete game", err);
    }
  };

  const getActiveGame = () => {
    return games.find(g => g.id === activeGameId);
  };

  return (
    <GameContext.Provider value={{ games, loading, error, addGame, updateGame, deleteGame, activeGameId, setActiveGameId, getActiveGame }}>
      {children}
    </GameContext.Provider>
  );
};
